
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'OnboardingBanner'
})
export default class OnboardingBanner extends Vue {
  @Prop({ required: true, type: Boolean })
  onboardingMode!: boolean;

  @Prop({ required: true, type: Boolean })
  isAthenaReady!: boolean;

  @Prop({ default: false, type: Boolean })
  isDataImportComplete!: boolean;

  /**
   * Determines if the banner should be displayed
   * Shows only when in onboarding mode AND data import is not finished
   */
  get shouldShow(): boolean {
    return this.onboardingMode && !this.isAthenaReady;
  }

  /**
   * Banner title based on import status
   */
  get title(): string {
    if (this.isDataImportComplete) {
      return 'Data Import Complete';
    }
    return 'Onboarding Mode Active';
  }

  /**
   * Banner message based on import status
   */
  get message(): string {
    if (this.isDataImportComplete) {
      return 'Your store data has been imported. Real data will be available shortly.';
    }
    return 'While your store data is being imported, explore the Report Builder with sample data! Create and save custom reports to "My Reports" - they\'ll automatically use your real data once the import completes.';
  }

  /**
   * Show progress indicator when import is in progress
   */
  get showProgress(): boolean {
    return !this.isDataImportComplete && this.onboardingMode;
  }
}
